import BaseAPI from './base'

class SchoolExamPeriodClassDetailAPI extends BaseAPI {}

export default new SchoolExamPeriodClassDetailAPI('v1/school-exam-period-class-details', 'SchoolExamPeriodClassDetail')
